import React from "react";
import { func, number, bool, oneOfType } from "prop-types";
import { connect } from "react-redux";
import {
  FormGroup,
  FormControl,
  FormLabel,
  Button,
  Form,
  Alert,
} from "react-bootstrap";
import circleCheck from "../../../resources/images/check-circle-dark.png";
import { partnersLogin } from "../actions";

export class PartnersLoginForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      emailAddress: "",
      password: "",
      loginFormValidated: false,
    };
  }

  updateLoginFormValidation = (loginFormValidated) => {
    this.setState({ loginFormValidated });
  };

  /* ----------- Event Handlers ------------- */
  handleInput = (event) => {
    const field = event.target.id;
    const { value } = event.target;

    this.setState({ [field]: value });
  };

  handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
      const form = e.currentTarget;
      if (form.checkValidity() === false) {
        e.stopPropagation();
        this.updateLoginFormValidation(true);
      } else {
        const formData = {
          emailAddress: this.state.emailAddress,
          password: this.state.password,
        };
        this.props.onLogin(formData);
      }
    }
  };

  handleLoginKeyPress = (event) => {
    if (event.charCode === 13) {
      this.handleSubmit();
    }
  };

  render() {
    // style variables
    const linkButtonStyle = {
      color: "#193783",
      textDecoration: "underline",
      backgroundColor: "none",
      border: "0",
      textAlign: "center",
      margin: 0,
      padding: 0,
    };

    /*
     * We set the errorMessage here, depending on which errorCode, if any, is returned from the login API call. Ideally,
     * this would be extracted to a separate method in a helper file, but the onClick handlers and styling doesn't pass
     * through correctly if it is.
     */

    let errorMessage;
    switch (this.props.partnersErrorCode) {
      case 1:
        errorMessage = (
          <div>
            Invalid email address and/or password.
            <br />
            Reset your password{" "}
            <button
              type="button"
              style={linkButtonStyle}
              onClick={this.props.showResetPasswordForm}
              id="resetPassword"
            >
              here
            </button>
            .
          </div>
        );
        break;
      case 2:
        errorMessage = (
          <div>
            <p>
              For security reasons, no more than 10 failed login attempts in a
              30 minute period are allowed. Please try again later.
            </p>
            <p>
              You can also unlock your account by resetting your password. Reset
              your password{" "}
              <button
                type="button"
                style={linkButtonStyle}
                onClick={this.props.showResetPasswordForm}
                id="resetPassword"
              >
                here
              </button>
              .
            </p>
          </div>
        );
        break;
      case 3:
        errorMessage = "Your account is inactive";
        break;
      default:
        errorMessage = null;
        break;
    }

    return (
      <>
        <h1
          style={{
            fontSize: "28px",
            lineHeight: "1.5",
            marginBottom: "16px",
          }}
          className="mt-0"
        >
          Criteria Partner Login
        </h1>
        {errorMessage ? (
          <Alert className="error-messages" variant="danger">
            <div>{errorMessage}</div>
          </Alert>
        ) : null}
        {this.props.partnersResetEmailSent && (
          <div
            style={{
              borderRadius: "3px",
              backgroundColor: "#eaf9fa",
              color: "#1f8e93",
              minWidth: "100%",
              marginBottom: "10px",
              textAlign: "left",
              paddingLeft: "7px",
              paddingTop: "10px",
              paddingBottom: "10px",
              fontSize: "14px",
            }}
          >
            <span className="mr-2" style={{ display: "inline-block" }}>
              <img
                src={circleCheck}
                alt="check inside circle"
                height="15px"
                width="15px"
                style={{
                  marginBottom: "3px",
                }}
              />
            </span>{" "}
            If your account exists in our database, we'll email you a reset
            link.
          </div>
        )}
        <Form
          noValidate
          validated={this.state.loginFormValidated}
          onSubmit={this.handleSubmit}
        >
          <FormGroup>
            <FormLabel className="mb-1">
              <strong>Email Address</strong>
            </FormLabel>
            <FormControl
              type="email"
              placeholder="Enter email address"
              id="emailAddress"
              value={this.state.emailAddress}
              onChange={this.handleInput}
              onKeyPress={this.handleLoginKeyPress}
              data-test="email"
              style={{ borderColor: "#b1b3b3" }}
              required
            />
            <Form.Control.Feedback type="invalid">
              Enter your email here
            </Form.Control.Feedback>
          </FormGroup>
          <FormGroup>
            <FormLabel className="mb-1">
              <strong>Password</strong>
            </FormLabel>
            <FormControl
              type="password"
              placeholder="Enter password"
              id="password"
              value={this.state.password}
              onChange={this.handleInput}
              onKeyPress={this.handleLoginKeyPress}
              data-test="password"
              style={{ borderColor: "#b1b3b3" }}
              required
            />
            <Form.Control.Feedback type="invalid">
              Enter your password here
            </Form.Control.Feedback>
          </FormGroup>
          <div className="text-center">
            <Button
              type="submit"
              variant="primary"
              size="lg"
              id="logIn"
              className="mt-3 mb-3"
              style={{ backgroundColor: "#425cc7", width: "100%" }}
              disabled={
                this.state.emailAddress === "" && this.state.password === ""
              }
            >
              Log In
            </Button>
            <br />
          </div>
        </Form>
        <div className="text-center">
          <button
            type="button"
            style={linkButtonStyle}
            onClick={this.props.showResetPasswordForm}
            id="forgotPassword"
          >
            Forgot password?
          </button>
        </div>
      </>
    );
  }
}
PartnersLoginForm.propTypes = {
  onLogin: func.isRequired,
  showResetPasswordForm: func.isRequired,
  partnersErrorCode: oneOfType([number, bool]),
  partnersResetEmailSent: bool,
};

const mapStateToProps = (state) => ({
  partnersErrorCode: state.get("App").get("partnersErrorCode"),
  newPasswordErrorMessage: state.get("App").get("newPasswordErrorMessage"),
});

function mapDispatchToProps(dispatch) {
  return {
    onLogin: (formData) => dispatch(partnersLogin(formData)),
    dispatch,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(PartnersLoginForm);
